export const navItems = [
  { id: "overview", label: "题材总览" },
  { id: "drama", label: "短剧盘点" },
  { id: "novel", label: "小说版" },
  { id: "movie", label: "电影版" },
  { id: "uncut", label: "未删减看点" },
  { id: "recommend", label: "类似推荐" },
  { id: "guide", label: "入坑顺序" },
  { id: "faq", label: "常见问题" },
];

export const quickFacts = [
  {
    icon: "ri-film-line",
    title: "短剧：密集反转",
    desc: "单集短、钩子密，开局几集就抛强冲突，适合碎片时间连着刷。",
  },
  {
    icon: "ri-book-open-line",
    title: "小说：心理纵深",
    desc: "文字能展开人物动机与内心挣扎，线索铺得慢但更扎实。",
  },
  {
    icon: "ri-movie-2-line",
    title: "电影：氛围优先",
    desc: "用光影、镜头与配乐建立情绪，节奏更克制，留白更多。",
  },
];

export const usageSteps = [
  "想知道「有哪些走向」→ 先看下方短剧版本盘点，四条主线横向对比。",
  "偏爱文字阅读 → 直接跳到小说版梳理，了解载体带来的差异。",
  "看重画面与表演 → 跳到电影版看点。",
  "担心删减 → 看未删减看点一栏，弄清常见增减方向。",
  "已经知道自己口味 → 用类似推荐的标签筛选，一步到位。",
];

export const dramaPatterns = [
  {
    tag: "误会与救赎线",
    keywords: ["错位", "隐忍", "和解"],
    plot: "主角因一次误会与邻家产生交集，矛盾在几集内集中爆发，随后靠关键证据或坦白逐步揭开真相，最终落到修复关系。",
    highlight: "情绪拉扯强，反派翻车的段落解气，适合需要情绪出口的观众。",
    image: "https://readdy.ai/api/search-image?query=warm%20cinematic%20abstract%20illustration%20of%20two%20overlapping%20translucent%20silhouettes%20separated%20by%20a%20soft%20light%20beam%2C%20terracotta%20and%20cream%20palette%2C%20painterly%20artistic%20style%2C%20dramatic%20mood%20lighting%2C%20emotional%20tension%20metaphor%2C%20no%20text%2C%20editorial%20poster%20aesthetic&width=800&height=600&seq=nw-drama-01&orientation=landscape",
  },
  {
    tag: "悬念推理线",
    keywords: ["线索", "反转", "身份"],
    plot: "邻居一家的异常举动成为悬念起点，主角一边处理关系一边收集线索，中段抛出身份层面的反转，把先前细节重新解释一遍。",
    highlight: "几乎每集都有一个小钩子，追更欲望强，适合喜欢推理和猜结局的观众。",
    image: "https://readdy.ai/api/search-image?query=moody%20abstract%20cinematic%20scene%20of%20a%20dimly%20lit%20window%20pattern%20with%20a%20single%20glowing%20curtain%20silhouette%2C%20deep%20amber%20and%20charcoal%20tones%2C%20mystery%20atmosphere%2C%20painterly%20artistic%20style%2C%20soft%20haze%2C%20no%20text%2C%20editorial%20aesthetic&width=800&height=600&seq=nw-drama-02&orientation=landscape",
  },
  {
    tag: "都市伦理线",
    keywords: ["边界", "责任", "选择"],
    plot: "聚焦婚姻与邻里的边界感，冲突来自现实压力而非极端设定，人物各有难处，结局多为克制或开放，不强行给标准答案。",
    highlight: "贴近生活，台词扎心，适合偏好现实题材、看重人物逻辑自洽的观众。",
    image: "https://readdy.ai/api/search-image?query=calm%20abstract%20depiction%20of%20a%20quiet%20apartment%20corridor%20at%20night%20with%20warm%20door%20light%2C%20muted%20taupe%20and%20cream%20palette%2C%20minimalist%20artistic%20illustration%2C%20soft%20shadows%2C%20quiet%20contemplative%20mood%2C%20no%20text%2C%20editorial%20aesthetic&width=800&height=600&seq=nw-drama-03&orientation=landscape",
  },
  {
    tag: "逆袭爽感线",
    keywords: ["觉醒", "反击", "翻盘"],
    plot: "主角前期被动受制，中段完成心态或能力上的觉醒，后半程一步步反击，把先前受的委屈连本带利找回场子。",
    highlight: "节奏干脆、打脸密集，适合想放松、追求爽感的观众，不用费心推理。",
    image: "https://readdy.ai/api/search-image?query=energetic%20abstract%20cinematic%20composition%20of%20a%20rising%20diagonal%20light%20striking%20through%20warm%20haze%2C%20crimson%20and%20gold%20palette%2C%20dynamic%20painterly%20artistic%20style%2C%20sense%20of%20momentum%20and%20triumph%2C%20no%20text%2C%20editorial%20poster%20aesthetic&width=800&height=600&seq=nw-drama-04&orientation=landscape",
  },
];

export const novelAspects = [
  {
    title: "视角与心理",
    desc: "小说常用第一人称或限制视角，读者只能跟着主角的判断走。误会、隐瞒和自欺因此更有代入感——你会先相信主角，再和主角一起被真相推翻。",
  },
  {
    title: "线索与伏笔",
    desc: "文字可以埋大量不显眼的细节，比如一次对话的停顿、一件反复出现的物品。这些在短剧里容易被压缩掉的信息，正是小说版反复咀嚼的乐趣所在。",
  },
  {
    title: "节奏与结局",
    desc: "小说能用慢节奏铺陈人物动机，让每个选择都有前因；结局也往往更暧昧，留出想象空间，而不是给出一个干脆的是非判断。",
  },
];

export const movieHighlights = [
  {
    title: "视听氛围先行",
    desc: "电影往往先用光影、构图和环境音建立情绪，再让台词进场。同一段关系，在安静的长镜头里会显得比密集对白更有压力。",
  },
  {
    title: "时间压缩与留白",
    desc: "两小时的容量决定了电影必须省略大量解释，用镜头段落代替说明。省略本身也是表达，观众需要自己把空白补齐。",
  },
  {
    title: "表演的微表情",
    desc: "大银幕会放大表情与肢体的细微差别，一个迟疑的眼神或收回的手，往往比一段台词承载了更多信息。",
  },
  {
    title: "结局的多义性",
    desc: "电影版更偏爱开放式收尾，把判断权交给观众。同一个画面，不同经历的人会读出完全不同的结论。",
  },
];

export const uncutPoints = [
  {
    title: "动机铺垫",
    desc: "删减版常砍掉解释角色为何做出某个选择的关键段落，导致行为看起来突兀。补上后，人物的逻辑会顺畅很多。",
  },
  {
    title: "情感线细节",
    desc: "更完整的相处片段，让关系的变化有过渡而非跳变。这些日常戏份往往最影响你对角色的好恶。",
  },
  {
    title: "支线人物前因",
    desc: "配角的前因后果被保留后，主线冲突的来源会更清楚，反转也更有说服力。",
  },
  {
    title: "结局处理力度",
    desc: "部分版本会调整结尾的呈现方式，或增加收束段落。力度不同，观感差别可能相当明显。",
  },
];

export const recommendTags = ["全部", "悬念推理", "情感救赎", "都市伦理", "逆袭爽感", "家庭纠葛"];

export const recommendations = [
  {
    title: "反转密集的悬疑向短剧",
    tags: ["悬念推理"],
    reason: "每集结尾都留钩子，身份反转在中期集中释放，适合喜欢边看边猜的人。",
    scene: "适合通勤或睡前连刷两三集",
    image: "https://readdy.ai/api/search-image?query=abstract%20cinematic%20poster%20of%20a%20question%20mark%20formed%20by%20warm%20light%20and%20shadow%20fragments%2C%20amber%20and%20charcoal%20palette%2C%20painterly%20artistic%20style%2C%20suspense%20mood%2C%20no%20text%2C%20editorial%20aesthetic&width=800&height=600&seq=nw-rec-01&orientation=landscape",
  },
  {
    title: "先虐后甜的情感救赎线",
    tags: ["情感救赎"],
    reason: "前期误会拉满情绪，中后段靠坦白与和解收束，甜点集中在后半程。",
    scene: "适合情绪需要出口的夜晚一口气看完",
    image: "https://readdy.ai/api/search-image?query=soft%20abstract%20illustration%20of%20two%20warm%20light%20sources%20gradually%20merging%20into%20one%2C%20cream%20and%20rose%20terracotta%20palette%2C%20gentle%20painterly%20style%2C%20hopeful%20healing%20mood%2C%20no%20text%2C%20editorial%20aesthetic&width=800&height=600&seq=nw-rec-02&orientation=landscape",
  },
  {
    title: "现实向的都市伦理剧集",
    tags: ["都市伦理"],
    reason: "冲突来自生活压力而非极端设定，人物各有立场，看完容易代入并反思。",
    scene: "适合喜欢慢热、看重台词质感的观众",
    image: "https://readdy.ai/api/search-image?query=minimal%20abstract%20city%20skyline%20at%20dusk%20rendered%20in%20muted%20taupe%20and%20cream%20tones%2C%20quiet%20reflective%20mood%2C%20painterly%20artistic%20style%2C%20subtle%20warm%20window%20lights%2C%20no%20text%2C%20editorial%20aesthetic&width=800&height=600&seq=nw-rec-03&orientation=landscape",
  },
  {
    title: "打脸爽感拉满的逆袭线",
    tags: ["逆袭爽感"],
    reason: "节奏干脆，主角从被动到主动的转折清晰，反击段密集且解气。",
    scene: "适合想放松、不想动脑的轻松时刻",
    image: "https://readdy.ai/api/search-image?query=dynamic%20abstract%20illustration%20of%20a%20bold%20upward%20light%20streak%20crossing%20warm%20crimson%20and%20gold%20textures%2C%20energetic%20painterly%20style%2C%20empowering%20triumphant%20mood%2C%20no%20text%2C%20editorial%20poster%20aesthetic&width=800&height=600&seq=nw-rec-04&orientation=landscape",
  },
  {
    title: "多代同堂的家庭纠葛题材",
    tags: ["家庭纠葛"],
    reason: "把矛盾放进家庭关系网里，长辈与晚辈的立场冲突层层递进，看点更耐嚼。",
    scene: "适合和家人一起看、边看边讨论",
    image: "https://readdy.ai/api/search-image?query=warm%20abstract%20illustration%20of%20overlapping%20family%20silhouette%20shapes%20around%20a%20glowing%20table%20lamp%2C%20ochre%20and%20cream%20palette%2C%20painterly%20artistic%20style%2C%20cozy%20yet%20tense%20family%20mood%2C%20no%20text%2C%20editorial%20aesthetic&width=800&height=600&seq=nw-rec-05&orientation=landscape",
  },
  {
    title: "悬疑与情感双线的复合题材",
    tags: ["悬念推理", "情感救赎"],
    reason: "一边查真相一边修复关系，两条线互相推动，既有推理的钩子也有情感的落点。",
    scene: "适合既要烧脑又想被感动的观众",
    image: "https://readdy.ai/api/search-image?query=abstract%20cinematic%20composition%20where%20two%20glowing%20threads%20intertwine%20across%20a%20warm%20dark%20background%2C%20amber%20and%20deep%20brown%20palette%2C%20painterly%20artistic%20style%2C%20mystery%20and%20warmth%20combined%2C%20no%20text%2C%20editorial%20aesthetic&width=800&height=600&seq=nw-rec-06&orientation=landscape",
  },
];

export const watchOrder = [
  {
    step: "01",
    title: "先用短剧摸清母题",
    desc: "短剧信息密度高、时长成本低，随便挑一条走向看几集，就能明白这类题材的看点和套路在哪里。",
  },
  {
    step: "02",
    title: "再读小说补人物动机",
    desc: "当你对某条走向产生兴趣，去找对应的小说版本，把短剧里被压缩掉的心理描写补齐。",
  },
  {
    step: "03",
    title: "最后看电影版看氛围",
    desc: "看过短剧和小说之后再看电影，你会更容易注意到镜头语言与留白，也更能体会表演细节。",
  },
  {
    step: "04",
    title: "按口味横向扩展",
    desc: "确定自己偏爱悬疑、救赎还是爽感后，用类似推荐的标签筛选，把同类作品一次补齐。",
  },
];

export const faqs = [
  {
    q: "「邻居的妻子」到底指一部作品，还是一类题材？",
    a: "更准确地说，它是一类被反复使用的题材母题。同名或相近题名的短剧、小说、电影版本都可能存在，剧情细节各不相同。本站按题材通览的方式整理共性走向，而不是替某一部作品下定义；具体到某一部，请以官方片源与出版物信息为准。",
  },
  {
    q: "标着「未删减」的版本，内容一定更完整吗？",
    a: "不一定。「未删减」有时是营销话术，不同平台与地区的实际增减差异很大。建议以官方公布的正片时长、分级信息和片源说明来判断，而不是只看标题字样。",
  },
  {
    q: "短剧、小说、电影，先看哪个不容易劝退？",
    a: "如果只是想快速判断自己喜不喜欢这个母题，先从短剧入手最省时间；如果你本来就爱看文字、在意人物动机，直接读小说反而更顺；电影适合已经熟悉故事、想体验氛围感的观众。",
  },
  {
    q: "类似推荐里的标签怎么用？",
    a: "在「类似推荐」分区点击上方标签即可即时筛选，选「全部」会显示所有条目。筛选只作用于本页已经存在的内容，不会跳转或联网加载。",
  },
  {
    q: "这些版本之间有观看顺序要求吗？",
    a: "没有硬性要求，各版本基本可以独立观看。不过如果你想最大化体验，可以参考页内的「新手入坑顺序」：先短剧、再小说、最后电影，感受会层层递进。",
  },
  {
    q: "页面上的内容是实时更新的吗？",
    a: "本站当前以静态内容整理为主，聚焦题材共性与通用说明，不依赖实时接口。涉及具体条目时，我们都给出了判断方法而非绝对结论，方便你自己核实。",
  },
];